import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';

import { AdfoxNew } from '../adfox/adfox';
import { adfoxNewMediaConstants } from '../adfox/constants';

import { HeroContainer } from '../../containers/HeroContainer';
import { DefaultBackground } from '../DefaultBackground';
import { Marquee } from './Marquee';
import { mergeStyles } from '@cian/utils';
import { OneTwoTripBannerContainer } from '../../containers/OneTwoTripBannerContainer';

const s = require('./filters_block.css');

const backgrounds: IBackgrounds = {
  index: s['c-filters-bg_home'],
  'daily-rent': s['c-filters-bg_daily-rent'],
  commercial: s['c-filters-bg_commercial'],
  sale: s['c-filters-bg_sale'],
  rent: s['c-filters-bg_rent'],
  'new-buildings': s['c-filters-bg_new-buildings'],
};

export interface IBackgrounds {
  [Identifier: string]: string;
}

interface IProps {
  section: string;
  backgroundImageUrl?: string;
  defaultBackgroundImageUrl?: string;
  backgroundShown: boolean;
  onLoadAdfox?(context: IAdFoxBannerOnLoadData): void;
  onStubAdfox?(): void;
  mediaInfoText?: string;
  mediaNote?: string;
  isNewFilters: boolean;
}

export const FiltersBlock: React.FC<IProps> = props => {
  const defaultImageUrlRef = React.useRef<string>(backgrounds[props.section]);
  const { isNewFilters } = props;

  return (
    <div
      {...mergeStyles(
        s['c-filters'],
        !props.backgroundShown && s['c-filters-transparent'],
        isNewFilters && s['c-filters--new'],
      )}
    >
      <div className={s['c-filters-content']}>
        <div className={s['c-filters-inner']}>
          {isNewFilters && <HeroContainer />}
          {!isNewFilters && props.children}
          <Marquee mediaNote={props.mediaNote} hasNewPlacement={isNewFilters} />
        </div>
        {/* на посуточной не нужна реклама */}
        {props.section !== 'daily-rent' && (
          <AdfoxNew
            constants={adfoxNewMediaConstants}
            section={props.section}
            onLoad={props.onLoadAdfox}
            onStub={props.onStubAdfox}
          />
        )}
      </div>
      {/* Убрать эксперимент в задаче https://jira.cian.tech/browse/CD-155309 */}
      {props.section === 'daily-rent' && <OneTwoTripBannerContainer />}
      {props.backgroundImageUrl && <div className={s['c-filters-content-overlay']}></div>}
      {isNewFilters && props.backgroundShown && !props.backgroundImageUrl && (
        <DefaultBackground section={props.section} imageUrl={props.defaultBackgroundImageUrl} />
      )}
      {(!isNewFilters || !!props.backgroundImageUrl) && (
        <div
          className={`${s['c-filters-bg']} ${defaultImageUrlRef.current}`}
          style={{
            // stylelint-disable
            backgroundImage: props.backgroundImageUrl ? `url(${props.backgroundImageUrl})` : '',
            // stylelint-enable
          }}
        />
      )}
    </div>
  );
};
